import React from "react";

import { useTranslation, Trans } from "react-i18next";
import Button from '../Button'
import img from '../../img/AboutUs/img.png'

function OurAmazing () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto pt-[120px] xl:pt-[160px]">
                <div className="flex flex-col xl:flex-row justify-between items-center">
                    <img src={img} alt="" />
                    <div className="xl:px-[70px]">
                        <p className="text-[32px] xl:text-[40px] italic font-[700] merriweather"><Trans>{t('about.7')}</Trans></p>
                        <p className="text-[14px] xl:text-[16px] font-[300] md:max-w-[418px] mt-[30px] inter">{t('about.8')}</p>
                        <Button className={"mt-[40px] hidden xl:block"}/>
                    </div>
                </div>
                <div className="flex flex-col xl:flex-row justify-between items-center xl:mt-[-35px] gap-[20px] xl:gap-0 mt-[20px]">
                    <div className="xl:px-[70px]">
                        <p className="text-[16px] xl:text-[25px] italic font-[700] merriweather"><Trans>{t('about.9')}</Trans></p>
                        <p className="text-[14px] xl:text-[16px] font-[300] md:max-w-[418px] mt-[15px] inter">{t('about.10')}</p>
                    </div>
                    <div className="xl:h-[263px] xl:bg-[#31D76B] xl:w-[610px] rounded-r-[120px] flex flex-col justify-center items-end">
                        <div className="xl:px-[70px]">
                            <p className="text-[16px] xl:text-[25px] italic font-[700] merriweather xl:text-white"><Trans>{t('about.11')}</Trans></p>
                            <p className="text-[14px] xl:text-[16px] font-[300] md:max-w-[418px] mt-[15px] inter xl:text-white">{t('about.12')}</p>
                        </div> 
                    </div>
                </div>
                <div className="flex flex-col xl:flex-row-reverse justify-between items-center gap-[20px] xl:gap-0">
                    <div className="xl:px-[70px]">
                        <p className="text-[14px] xl:text-[16px] font-[300] md:max-w-[418px] mt-[15px] inter">{t('about.15')}</p>
                    </div>
                    <div className="xl:h-[263px] xl:bg-[#353535] xl:w-[610px] rounded-l-[120px] flex flex-col justify-center">
                        <div className="xl:px-[70px]">
                            <p className="text-[16px] xl:text-[25px] italic font-[700] merriweather xl:text-white"><Trans>{t('about.13')}</Trans></p>
                            <p className="text-[14px] xl:text-[16px] font-[300] md:max-w-[418px] mt-[15px] inter xl:text-white">{t('about.14')}</p>
                        </div>
                        <Button className={"mt-[40px] xl:hidden block"}/> 
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OurAmazing;